import { APIConstantsInterface } from './types';

export enum APIConstantEnums {
  AUTH,
  USER,
  STATUS_CONFIG,
  STORE_CONFIG,
  RESOURCE,
  REPORT,
  PO,
  MARGIN,
  APPROVALS,
  BULK_PO,
  COMMON,
  ASN,
  NEXUS_ENUM,
  PRICING,
  BULK_JOBS,
  BULK_REPORT,
  PO_APPROVAL,
  PO_RETURN,
}

export enum AuthAPIEndpoints {
  VERIFY = 'api/v1/auth/verify-invited-user',
  LOGIN = 'api/v1/auth/sign-in',
  FORGOT_PASSWORD = 'api/v1/auth/forgot-password-invited',
  RESET_PASSWORD = 'api/v1/auth/reset-password',
  SEND_OTP = 'api/v1/auth/resend-code',
  GET_USER_BY_CODE = 'api/v1/auth/get-user-by-code',
  LOGOUT = 'seller/api/v1/auth/sign-out',
  REQUEST_ACCESS = 'api/v1/auth/request-access-for-application',
  GET_ACCESS_DATA = 'api/v2/authorize/fetch-all-modules-for-an-application',
}

export enum UserAPIEndpoints {
  GET_USERS_LIST = 'seller/api/v1/access-management/users',
  ADD_NEW_USER = 'seller/api/v1/access-management/external-user',
  DISABLE_USER = 'api/v1/auth/remove-user-application-access',
}

export enum StatusConfigApiEndpoints {
  GET_STATUS_CONFIG = 'seller/api/v1/resource/approval-status/list',
}

export enum StoreConfigApiEndpoints {
  GET_STORE_CONFIG = 'seller/api/v1/location/store/list',
  GET_STORE_FILTER_OPTIONS = '/seller/api/v1/location/store/list',
}

export enum ResourceApiEndpoints {
  GET_RESOURCE_LIST = 'seller/api/v1/resource/list',
  REVIEW_RESOURCE = 'seller/api/v1/resource/review',
  GET_SKU_LIST = 'seller/api/v1/catalog/list',
  REVIEW_SKU = 'seller/api/v1/catalog/review',
  GET_ENTITY_IDS = 'seller/api/v1/resource/scope/list',
}

export enum ReportApiEndpoints {
  GET_REPORT_LIST = 'seller/api/v1/report',
  RETRY_REPORT_DOWNLOAD = 'seller/api/v1/report/:id/retry',
  REPORT_DOWNLOAD = 'seller/api/v1/report/:id/download',
  REPORT_REQUEST = 'seller/api/v1/report',
}

export enum POApiEndpoints {
  GET_PO_LIST = 'nexus/api/v1/po/view',
  EDIT_PO_LINE_ITEMS = 'nexus/api/v1/po-line-items/edit',
  GET_PO_LINE_ITEM_LIST = 'nexus/api/v1/po/line-item-summary',
  GET_PO_EDIT_VIEW = 'nexus/api/v1/po-line-items/edit-view',
  GET_PO_LINE_ITEM_SUMMARY = 'nexus/api/v1/po/summary',
  CANCEL_PO = 'nexus/api/v1/po/cancel',
  GET_BULK_REPORT = 'nexus/api/v1/reports/request-report/BULK_PO_REPORT',
  PO_STATUS_COUNT = 'nexus/api/v1/upload/po-status-counts',
  UPDATE_PO = 'nexus/api/v1/po/edit',
  CREATE_PDF = 'nexus/api/v1/po/create-po-pdf',
  GET_EDITABLE_FIELDS_CONFIG = 'nexus/api/v1/po/edit-view',
}

export enum MarginApiEndpoints {
  GET_MARGIN = 'nexus/api/v1/margin',
  UPLOAD_MARGIN = 'nexus/api/v1/margin',
  GET_MARGIN_UPLOADS = 'nexus/api/v1/margin/uploads',
}

export enum ApprovalsApiEndpoints {
  GET_APPROVALS = 'nexus/api/v1/po/approve-view',
  APPROVE_PO = 'nexus/api/v1/po/approve',
  APPROVE_JOB = 'nexus/api/v1/bulk-job/approve-job',
  CANCEL_JOB = 'nexus/api/v1/bulk-job/cancel-job',
}

export enum BulkPOApiEndpoints {
  GET_BULK_PO_LIST = 'nexus/api/v1/upload/list-bulk-pos',
  UPLOAD_BULK_PO = 'nexus/api/v1/upload/finalize-upload',
}

export enum CommonApiEndpoints {
  GET_DOWNLOAD_URL = 'nexus/api/v1/upload/get-download-url',
  GET_UPLOAD_URL = 'nexus/api/v1/upload/get-upload-url',
  GET_TEMPLATE_DOWNLOAD_URL = 'nexus/api/v1/upload/get-template-download-url',
  GET_REPORT_DATA = 'nexus/api/v1/reports/generate',
}

export enum ASNApiEndpoints {
  GET_ASN_LIST = 'nexus/api/v1/asn',
  CREATE_ASN = 'nexus/api/v1/asn',
  CANCEL_ASN = 'nexus/api/v1/asn/cancel',
  CREATE_BULK_ASN = 'nexus/api/v1/asn/create-bulk',
  CONFIRM_ASN = 'nexus/api/v1/asn/confirm',
  Exceptional_ASN_Handling = 'nexus/api/v1/asn/exceptional-asn-handling',
  CONFIRM_BULK_ASN = 'nexus/api/v1/asn/confirm-bulk',
  GET_ASN_VALUE = 'nexus/api/v1/asn/total-value',
  GET_EXCEPTIONAL_ASN = 'nexus/api/v1/exceptional-asn/list',
  DISCARD_ASN = 'nexus/api/v1/exceptional-asn/discard',
  GET_DOWNLOAD_URL = 'nexus/api/v1/attachment/generate-attachment-url',
  EXCEPTIONAL_ASN_CREATE = 'nexus/api/v1/exceptional-asn/create-asn',
  VALIDATE_BULK_ASN_CONFIRMATION = 'nexus/api/v1/asn/validate-bulk-confirm',
}

export enum NexusEnumApiEndpoints {
  LOAD_ENUM = 'nexus/api/v1/enumerations/enums',
}

export enum PricingApiEndpoints {
  GET_SKU_LIVE_LISTING = 'seller/pricing/api/v1/recommendation/get-single-live-prices',
  GET_SKU_SUGGESTION_LISTING = 'seller/pricing/api/v1/recommendation/get-single-recommended-prices',
  GET_BUNDLE_LIVE_LISTING = 'seller/pricing/api/v1/recommendation/get-bundle-live-prices',
  GET_BUNDLE_SUGGESTION_LISTING = 'seller/pricing/api/v1/recommendation/get-bundle-recommended-prices',
  GET_PRESIGNED_URL_FOR_UPLOAD_ACTION = 'seller/pricing/api/v1/update/upload-prices',
  GET_UPLOAD_TEMPLATE = 'seller/pricing/api/v1/update/upload-prices-template',
  REJECT_SELECTED_ACTION = 'seller/pricing/api/v1/recommendation/reject-selected',
  APPROVE_ALL_ACTION = 'seller/pricing/api/v1/recommendation/approve-all',
  GET_CBP_REJECTION_LISTING = 'seller/pricing/api/v1/recommendation/get-rejected-recommendations-report',
  GET_PRESIGHNED_REPORT_URL = 'seller/pricing/api/v1/recommendation/get-presigned-report-url',
  GET_HISTORICAL_PRICING = 'seller/pricing/api/v1/recommendation/get-historical-prices-report',
  CREATE_HISTORICAL_PRICE_DOWNLOAD = '/seller/pricing/api/v1/recommendation/get-historical-prices',
  GET_PRE_SIGNED_URL_CONTEXTUAL_DISCOUNT = 'seller/pricing/api/v1/contextual_discounts/pre_signed_url',
}

export enum BulkJobsEndpoints {
  BULK_JOB_LIST = 'nexus/api/v1/bulk-job/list-bulk-jobs',
  GET_UPLOAD_URL = 'nexus/api/v1/bulk-job/get-upload-url',
  FINALIZE_JOB = 'nexus/api/v1/bulk-job/finalize-upload',
  GET_TEMPLATE_URL = 'nexus/api/v1/bulk-job/get-template-download-url',
}

export enum BulkReportEndpoints {
  GET_BULK_REPORT = 'nexus/api/v1/reports/list-report',
}

export enum POApprovalAPIEndpoints {
  DOWNLOAD_SUGGESTION_FILE = 'seller/api/v1/transfer/batch/',
}

export enum POReturnAPIEndpoints {
  DOWNLOAD_SUGGESTION_FILE = 'seller/file-job/download-file',
}

export const APIEndpointsMap: Record<APIConstantEnums, any> = {
  [APIConstantEnums.AUTH]: AuthAPIEndpoints,
  [APIConstantEnums.USER]: UserAPIEndpoints,
  [APIConstantEnums.STATUS_CONFIG]: StatusConfigApiEndpoints,
  [APIConstantEnums.STORE_CONFIG]: StoreConfigApiEndpoints,
  [APIConstantEnums.RESOURCE]: ResourceApiEndpoints,
  [APIConstantEnums.REPORT]: ReportApiEndpoints,
  [APIConstantEnums.PO]: POApiEndpoints,
  [APIConstantEnums.MARGIN]: MarginApiEndpoints,
  [APIConstantEnums.APPROVALS]: ApprovalsApiEndpoints,
  [APIConstantEnums.BULK_PO]: BulkPOApiEndpoints,
  [APIConstantEnums.COMMON]: CommonApiEndpoints,
  [APIConstantEnums.ASN]: ASNApiEndpoints,
  [APIConstantEnums.NEXUS_ENUM]: NexusEnumApiEndpoints,
  [APIConstantEnums.PRICING]: PricingApiEndpoints,
  [APIConstantEnums.BULK_JOBS]: BulkJobsEndpoints,
  [APIConstantEnums.BULK_REPORT]: BulkReportEndpoints,
  [APIConstantEnums.PO_APPROVAL]: POApprovalAPIEndpoints,
  [APIConstantEnums.PO_RETURN]: POReturnAPIEndpoints,
};

export const APIConstants: APIConstantsInterface = {
  AUTH: {
    VERIFY: AuthAPIEndpoints.VERIFY,
    LOGIN: AuthAPIEndpoints.LOGIN,
    FORGOT_PASSWORD: AuthAPIEndpoints.FORGOT_PASSWORD,
    RESET_PASSWORD: AuthAPIEndpoints.RESET_PASSWORD,
    SEND_OTP: AuthAPIEndpoints.SEND_OTP,
    GET_USER_BY_CODE: AuthAPIEndpoints.GET_USER_BY_CODE,
    LOGOUT: AuthAPIEndpoints.LOGOUT,
    REQUEST_ACCESS: AuthAPIEndpoints.REQUEST_ACCESS,
    GET_ACCESS_DATA: AuthAPIEndpoints.GET_ACCESS_DATA,
  },
  USER: {
    GET_USERS_LIST: UserAPIEndpoints.GET_USERS_LIST,
    ADD_NEW_USER: UserAPIEndpoints.ADD_NEW_USER,
    DISABLE_USER: UserAPIEndpoints.DISABLE_USER,
  },
  STATUS_CONFIG: {
    GET_STATUS_CONFIG: StatusConfigApiEndpoints.GET_STATUS_CONFIG,
  },
  STORE_CONFIG: {
    GET_STORE_CONFIG: StoreConfigApiEndpoints.GET_STORE_CONFIG,
    GET_STORE_FILTER_OPTIONS: StoreConfigApiEndpoints.GET_STORE_FILTER_OPTIONS,
  },
  RESOURCE: {
    GET_RESOURCE_LIST: ResourceApiEndpoints.GET_RESOURCE_LIST,
    REVIEW_RESOURCE: ResourceApiEndpoints.REVIEW_RESOURCE,
    GET_SKU_LIST: ResourceApiEndpoints.GET_SKU_LIST,
    REVIEW_SKU: ResourceApiEndpoints.REVIEW_SKU,
    GET_ENTITY_IDS: ResourceApiEndpoints.GET_ENTITY_IDS,
  },
  REPORT: {
    GET_REPORT_LIST: ReportApiEndpoints.GET_REPORT_LIST,
    RETRY_REPORT_DOWNLOAD: (id: string) =>
      ReportApiEndpoints.RETRY_REPORT_DOWNLOAD.replace(':id', id),
    REPORT_DOWNLOAD: (id: string) =>
      ReportApiEndpoints.REPORT_DOWNLOAD.replace(':id', id),
    REPORT_REQUEST: ReportApiEndpoints.REPORT_REQUEST,
  },
  PO: {
    GET_PO_LIST: POApiEndpoints.GET_PO_LIST,
    EDIT_PO_LINE_ITEMS: POApiEndpoints.EDIT_PO_LINE_ITEMS,
    GET_PO_LINE_ITEM_LIST: POApiEndpoints.GET_PO_LINE_ITEM_LIST,
    GET_PO_EDIT_VIEW: POApiEndpoints.GET_PO_EDIT_VIEW,
    GET_PO_LINE_ITEM_SUMMARY: POApiEndpoints.GET_PO_LINE_ITEM_SUMMARY,
    CANCEL_PO: POApiEndpoints.CANCEL_PO,
    GET_BULK_REPORT: POApiEndpoints.GET_BULK_REPORT,
    PO_STATUS_COUNT: POApiEndpoints.PO_STATUS_COUNT,
    UPDATE_PO: POApiEndpoints.UPDATE_PO,
    CREATE_PDF: POApiEndpoints.CREATE_PDF,
    GET_EDITABLE_FIELDS_CONFIG: POApiEndpoints.GET_EDITABLE_FIELDS_CONFIG,
  },
  MARGIN: {
    GET_MARGIN: MarginApiEndpoints.GET_MARGIN,
    GET_MARGIN_UPLOADS: MarginApiEndpoints.GET_MARGIN_UPLOADS,
    UPLOAD_MARGIN: MarginApiEndpoints.UPLOAD_MARGIN,
  },
  APPROVALS: {
    GET_APPROVALS: ApprovalsApiEndpoints.GET_APPROVALS,
    APPROVE_PO: ApprovalsApiEndpoints.APPROVE_PO,
    APPROVE_JOB: (jobType: string, jobId: string) =>
      `${ApprovalsApiEndpoints.APPROVE_JOB}/${jobType}/${jobId}`,
    CANCEL_JOB: (jobType: string, jobId: string) =>
      `${ApprovalsApiEndpoints.CANCEL_JOB}/${jobType}/${jobId}`,
  },
  BULK_PO: {
    GET_BULK_PO_LIST: BulkPOApiEndpoints.GET_BULK_PO_LIST,
    UPLOAD_BULK_PO: BulkPOApiEndpoints.UPLOAD_BULK_PO,
  },
  COMMON: {
    GET_DOWNLOAD_URL: CommonApiEndpoints.GET_DOWNLOAD_URL,
    GET_UPLOAD_URL: CommonApiEndpoints.GET_UPLOAD_URL,
    GET_TEMPLATE_DOWNLOAD_URL: CommonApiEndpoints.GET_TEMPLATE_DOWNLOAD_URL,
    GET_REPORT_DATA: CommonApiEndpoints.GET_REPORT_DATA,
  },
  ASN: {
    GET_ASN_LIST: ASNApiEndpoints.GET_ASN_LIST,
    CREATE_ASN: ASNApiEndpoints.CREATE_ASN,
    CANCEL_ASN: ASNApiEndpoints.CANCEL_ASN,
    CREATE_BULK_ASN: ASNApiEndpoints.CREATE_BULK_ASN,
    CONFIRM_ASN: ASNApiEndpoints.CONFIRM_ASN,
    Exceptional_ASN_Handling: ASNApiEndpoints.Exceptional_ASN_Handling,
    CONFIRM_BULK_ASN: ASNApiEndpoints.CONFIRM_BULK_ASN,
    GET_ASN_VALUE: ASNApiEndpoints.GET_ASN_VALUE,
    GET_EXCEPTIONAL_ASN: ASNApiEndpoints.GET_EXCEPTIONAL_ASN,
    DISCARD_ASN: ASNApiEndpoints.DISCARD_ASN,
    GET_DOWNLOAD_URL: ASNApiEndpoints.GET_DOWNLOAD_URL,
    EXCEPTIONAL_ASN_CREATE: ASNApiEndpoints.EXCEPTIONAL_ASN_CREATE,
    VALIDATE_BULK_ASN_CONFIRMATION:
      ASNApiEndpoints.VALIDATE_BULK_ASN_CONFIRMATION,
  },
  NEXUS_ENUM: {
    LOAD_ENUM: NexusEnumApiEndpoints.LOAD_ENUM,
  },
  PRICING: {
    GET_SKU_LIVE_LISTING: PricingApiEndpoints.GET_SKU_LIVE_LISTING,
    GET_SKU_SUGGESTION_LISTING: PricingApiEndpoints.GET_SKU_SUGGESTION_LISTING,
    GET_BUNDLE_LIVE_LISTING: PricingApiEndpoints.GET_BUNDLE_LIVE_LISTING,
    GET_BUNDLE_SUGGESTION_LISTING:
      PricingApiEndpoints.GET_BUNDLE_SUGGESTION_LISTING,
    GET_PRESIGNED_URL_FOR_UPLOAD_ACTION:
      PricingApiEndpoints.GET_PRESIGNED_URL_FOR_UPLOAD_ACTION,
    REJECT_SELECTED_ACTION: PricingApiEndpoints.REJECT_SELECTED_ACTION,
    APPROVE_ALL_ACTION: PricingApiEndpoints.APPROVE_ALL_ACTION,
    GET_UPLOAD_TEMPLATE: PricingApiEndpoints.GET_UPLOAD_TEMPLATE,
    GET_CBP_REJECTION_LISTING: PricingApiEndpoints.GET_CBP_REJECTION_LISTING,
    GET_PRESIGHNED_REPORT_URL: PricingApiEndpoints.GET_PRESIGHNED_REPORT_URL,
    GET_HISTORICAL_PRICING: PricingApiEndpoints.GET_HISTORICAL_PRICING,
    CREATE_HISTORICAL_PRICE_DOWNLOAD:
      PricingApiEndpoints.CREATE_HISTORICAL_PRICE_DOWNLOAD,
    GET_PRE_SIGNED_URL_CONTEXTUAL_DISCOUNT:
      PricingApiEndpoints.GET_PRE_SIGNED_URL_CONTEXTUAL_DISCOUNT,
  },
  BULK_JOBS: {
    BULK_JOB_LIST: BulkJobsEndpoints.BULK_JOB_LIST,
    GET_UPLOAD_URL: (jobType: string) =>
      `${BulkJobsEndpoints.GET_UPLOAD_URL}/${jobType}`,
    FINALIZE_JOB: BulkJobsEndpoints.FINALIZE_JOB,
    GET_TEMPLATE_URL: BulkJobsEndpoints.GET_TEMPLATE_URL,
  },
  BULK_REPORT: {
    GET_BULK_REPORT: BulkReportEndpoints.GET_BULK_REPORT,
  },
  PO_APPROVAL: {
    DOWNLOAD_SUGGESTION_FILE: (resourceId: string, sellerCode: string) =>
      `${POApprovalAPIEndpoints.DOWNLOAD_SUGGESTION_FILE}${resourceId}/seller/${sellerCode}/items`,
  },
  PO_RETURN: {
    DOWNLOAD_SUGGESTION_FILE: POReturnAPIEndpoints.DOWNLOAD_SUGGESTION_FILE,
  },
};
